// extracted by mini-css-extract-plugin
export default {"plain-text":"v28CyGRxxX","plainText":"v28CyGRxxX"};
    if(module.hot) {
      // 1648553836183
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  